
import { Component, mixins } from '@niknevis/vue-modules'
import AdminTicketNewAnswerForm from '@/modules/ticket-answer/components/admin/AdminTicketNewAnswerForm.vue'
import { NewAnswerTicketUseCase } from '@/modules/ticket/use-cases/shared/new-answer-ticket.use-case'

@Component
export default class TicketNewAnswerForm extends mixins(AdminTicketNewAnswerForm) {
  constructor(
    private readonly newAnswerTicketUseCase: NewAnswerTicketUseCase
  ) {
    super()
  }

  showPredefined = false

  get isLoading() {
    return this.newAnswerTicketUseCase.isLoading
  }

  onSubmit() {
    this.newAnswerTicketUseCase.execute(this.ticketData.id, this.answerRequest)
      .then(() => {
        this.answerRequest = this.initRequest()
      })
  }
}
